import { createContext } from 'react'

// https://react.dev/reference/react/createContext#createcontext
const AppContext = createContext(null)

export default AppContext
